module.exports = __webpack_public_path__ + "img/11.6c144575.svg";